import {
  CREATE_USER_CALENDAR_MUTATION,
  CreateUserCalendarData
} from 'src/api/onboarding/mutations/createUserCalendar'
import { useMutation } from '@apollo/client'
import { ONBOARDING_STATUS_QUERY } from 'src/api/onboarding/queries/onboardingStatus'

export function useCreateUserCalendar({
  onCompleted,
  onError
}: {
  onCompleted?: (data: CreateUserCalendarData) => void
  onError?: (error: any) => void
} = {}) {
  const [createUserCalendar, rest] = useMutation<CreateUserCalendarData>(
    CREATE_USER_CALENDAR_MUTATION,
    {
      onCompleted,
      onError,
      refetchQueries: [
        {
          query: ONBOARDING_STATUS_QUERY
        }
      ]
    }
  )

  return {
    createUserCalendar,
    ...rest
  }
}
